/* import __COLOCATED_TEMPLATE__ from './objective-sort-manager.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';
import sortableByPosition from 'ilios-common/utils/sortable-by-position';
import { all } from 'rsvp';
import { action } from '@ember/object';
import { TrackedAsyncData } from 'ember-async-data';
let ObjectiveSortManagerComponent = (_class = class ObjectiveSortManagerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "totalObjectivesToSave", _descriptor, this);
    _initializerDefineProperty(this, "currentObjectivesSaved", _descriptor2, this);
    _initializerDefineProperty(this, "draggingItem", _descriptor3, this);
    _initializerDefineProperty(this, "draggedAboveItem", _descriptor4, this);
    _initializerDefineProperty(this, "draggedBelowItem", _descriptor5, this);
    _initializerDefineProperty(this, "sortedItems", _descriptor6, this);
    _initializerDefineProperty(this, "expanded", _descriptor7, this);
    _defineProperty(this, "saveSortOrder", _buildTask(() => ({
      context: this,
      generator: function* () {
        const objectives = this.items;
        for (let i = 0, n = objectives.length; i < n; i++) {
          objectives[i].set('position', i + 1);
        }
        this.totalObjectivesToSave = objectives.length;
        this.currentObjectivesSaved = 0;
        yield this.saveSomeObjectives(objectives);
        this.args.close();
      }
    }), null, "saveSortOrder", "drop"));
  }
  get objectives() {
    return new TrackedAsyncData(this.args.subject.xObjectives);
  }
  get sortedObjectives() {
    if (!this.objectives.isResolved) {
      return [];
    }
    return this.objectives.value.slice().sort(sortableByPosition);
  }
  get items() {
    return this.sortedItems ?? this.sortedObjectives;
  }
  get saveProgress() {
    const total = this.totalObjectivesToSave || 1;
    const current = this.currentObjectivesSaved || 0;
    return Math.floor(current / total * 100);
  }
  async saveSomeObjectives(arr) {
    const chunk = arr.splice(0, 5);
    await await all(chunk.map(o => o.save()));
    if (arr.length) {
      this.currentObjectivesSaved += chunk.length;
      await this.saveSomeObjectives(arr);
    }
  }
  resetHover() {
    this.draggedAboveItem = null;
    this.draggedBelowItem = null;
  }
  drag(item) {
    this.draggingItem = item;
  }
  dragEnd() {
    if (this.draggedAboveItem || this.draggedBelowItem) {
      const arr = [...this.items].filter(item => item !== this.draggingItem);
      if (this.draggedAboveItem) {
        const index = arr.indexOf(this.draggedAboveItem);
        arr.splice(index, 0, this.draggingItem);
      } else if (this.draggedBelowItem) {
        const index = arr.indexOf(this.draggedBelowItem);
        arr.splice(index + 1, 0, this.draggingItem);
      }
      this.sortedItems = arr;
    }
    this.resetHover();
    this.draggingItem = null;
  }
  dragOver(item, evt) {
    evt.preventDefault();
    this.resetHover();
    if (item !== this.draggingItem) {
      const bounding = evt.target.getBoundingClientRect();
      const offset = bounding.y + bounding.height / 2;
      if (evt.clientY - offset > 0) {
        this.draggedBelowItem = item;
      } else {
        this.draggedAboveItem = item;
      }
    }
  }
  toggleExpansion() {
    this.expanded = !this.expanded;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "totalObjectivesToSave", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentObjectivesSaved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "draggingItem", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "draggedAboveItem", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "draggedBelowItem", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortedItems", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "expanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "objectives", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "objectives"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "drag", [action], Object.getOwnPropertyDescriptor(_class.prototype, "drag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragEnd", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dragOver", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dragOver"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleExpansion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleExpansion"), _class.prototype), _class);
export { ObjectiveSortManagerComponent as default };